
export enum EnvironmentNames {
    enterprise = 'Ent',
    dev = 'Dev',
    test = 'Test',
    testlocal = "Testlocal",
    stage = 'Stage',
    sandbox = 'Sandbox',
    prod = 'Prod',
    feature = 'Feature'
  }